/**
 * The function adjusts the Slick carousel based on the window width and a specified breakpoint.
 * @param carousel - The `carousel` parameter is the selector of the elements wrapper
 * @param options - Slick carousel options
 * @param [breakpoint=800] - The `breakpoint` determines at what viewport width the carousel will be destroyed
 */
function handleSlickForMobile(carousel, options, breakpoint = 800) {
  console.log(carousel, options)
  var width = $(window).width();
  if (width >= breakpoint && carousel.hasClass('slick-slider')) {
    carousel.slick('unslick');
  } else if (width < breakpoint && !carousel.hasClass('slick-slider')) {
    carousel.slick(options);
  }
}


$(document).ready(function () {
  const sponsors = $('.landing-hero__footer-sponsors');
  const sponsorsOptions = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: '24px',
  };

  handleSlickForMobile(sponsors, sponsorsOptions);
  $(window).resize(function () {
    handleSlickForMobile(sponsors, sponsorsOptions);
  });


  $('.hm_testimonials_carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '80px',
    arrows: true,
    dots: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: '80px'
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px'
        }
      }
    ]
  });
  // Ingredients
  $('.ln_ingr_btn').click(function () {
    $('.ln_ingr_btn').removeClass('active');
    $(this).addClass('active');
    var currentId = $(this).attr('data-id');
    $('.ln_ingredients_block').removeClass('active');
    $('.ln_ingredients_block[data-id="' + currentId + '"]').addClass('active');
    $('.ln_ingr_container_carousel').slick('refresh');
  });
  $('.ln_ingr_cell_block').click(function () {
    $(this).toggleClass('active');
    $(this).find('.ln_ingr_block_cont').slideToggle();
  });
  $('.ln_ingr_container_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});





$('.ScrollToProduct').on('click', function (e) {
  e.preventDefault();
  const currentScroll = $(window).scrollTop();
  const closestSection = $('.product-main').toArray().reduce((closest, section) => {
    const offset = $(section).offset().top;
    return Math.abs(offset - currentScroll) < Math.abs($(closest).offset().top - currentScroll) ? section : closest;
  });

  if (closestSection) {
    $('html, body').animate({
      scrollTop: $(closestSection).offset().top - 150
    }, 800);
  }
});


// Product Selection
$(document).ready(function () {
  function selectorHandler(container, itemClass, displayTarget, getTextCallback) {
    $(`${container} ${itemClass}`).click(function () {
      if (!$(this).hasClass('active')) {
        $(`${container} ${itemClass}`).removeClass('active');
        $(this).addClass('active');
        const value = getTextCallback($(this));
        $(displayTarget).text(' ' + value);
      }
    });
  }
  // Product Selector
  selectorHandler('.product-main__product', '', '.product-main__choose-product span', el => el.find('.product-main__product-title').text());

  let selectedColor = $('.color-options.active .product-colors .Color_selector.active').data('color');
  let selectedSize = $('.product-sizes .Size_selector.active').data('size');

  function updatePrice() {
    const priceEl = $('.product-main__product.special .product-main__price strong');
    const compareEl = $('.product-main__product.special .product-main__price p');

    const maxPrices = $('.product-main__product.max');
    const maxPrice = maxPrices.data('price');
    const maxCompare = maxPrices.data('compare-price');

    const productData = $(`#variants-data .variant-data[data-color="${selectedColor}"][data-size="${selectedSize}"]`);
    const specPrice = productData.data('price');
    const specCompare = productData.data('compare-price');

    const price = ((specPrice + maxPrice) / 100).toFixed(2);
    const comparePrice = ((specCompare + maxCompare) / 100).toFixed(2);
    console.log(price, comparePrice);

    priceEl.text(`${price} €`);
    compareEl.text(`${comparePrice} €`);
  }

  // Color Selector
  $('.product-colors .Color_selector').click(function () {
    if (!$(this).hasClass('active')) {
      selectedColor = $(this).data('color');

      $('.product-colors .Color_selector').removeClass('active');
      $(this).addClass('active');
      $('.product-main__choose-color span').text(' ' + selectedColor);
      updatePrice();
    }
  });

  // Handle size selection
  $('.product-sizes .Size_selector').on('click', function () {
    selectedSize = $(this).data('size');

    // Update size selection
    $('.product-sizes .Size_selector').removeClass('active');
    $(this).addClass('active');
    $('.product-main__choose-size span').text($(this).text());

    // Show the matching color options for the selected size
    $('.color-options').removeClass('active');
    const activeColors = $(`.color-options-${selectedSize}`)
    activeColors.addClass('active');
    activeColors.find('.Color_selector.active').removeClass('active');
    const firstActiveColor = activeColors.find('.Color_selector:first-of-type');
    selectedColor = firstActiveColor.data('color');
    firstActiveColor.addClass('active');
    $('.product-main__choose-color span').text(' ' + firstActiveColor.data('color'));
    updatePrice();
  });

  // Quantity Update
  $('.product-main__quantity-selector .plus, .product-main__quantity-selector .minus').click(function () {
    const quantityElement = $(this).siblings('.quantity-num');
    let currentQuantity = parseInt(quantityElement.text());

    if ($(this).hasClass('plus')) {
      currentQuantity++;
    } else if ($(this).hasClass('minus') && currentQuantity > 0) {
      currentQuantity--;
    }

    quantityElement.data('quantity', currentQuantity);
    quantityElement.text(currentQuantity);
  });

  // $('.product-main__product.active .product-main__atc-wrapper.LMobile-only .product-main__atc-btn, .product-main__atc-wrapper.LDesktop-only .product-main__atc-btn').click(function (e) {
  // $('.product-main__atc-wrapper #add-to-cart-button').click(function (e) {
  //   e.preventDefault();

  //   const selectedProduct = $('.product-main__product.active');
  //   const quantity = $('.active .product-main__quantity-selector .quantity-num').data('quantity') || $('.product-main__atc-wrapper .product-main__quantity-selector .quantity-num').data('quantity') || 1;
  //   let items = [];
  //   let id = selectedProduct.data('id');

  //   items.push({ id, quantity })
  //   console.log(selectedProduct)
  //   if (selectedProduct.hasClass('special')) {
  //     const selectedColor = $('.product-colors .Color_selector.active').data('color');
  //     const selectedSize = $('.product-sizes .Size_selector.active').data('size');

  //     const productData = $(`#variants-data .variant-data[data-color="${selectedColor}"][data-size="${selectedSize}"]`);
  //     const id = productData.data('id');
  //     items.push({ id, quantity })
  //   }

  //   const data = items.length > 1 ? { items } : items[0];
  //   console.log(data);
  //   postToCart(items);
  // })

  // function postToCart(data) {
  //   $.post("/cart/add.js", data, function () {
  //     window.location.href = '/checkout';
  //   }).fail((err) => alert('Error adding the items to the cart.'));
  // }

});